import {
  $get,
  $post
} from '@/utils/http'
//首页
export default {
  //轮播图
  SearchHomePageFilesApi(params) {
    return $post('HomePage/SearchHomePageFiles', params)
  },

  // 新闻咨询查询
  SearchNewsHomePage_HZsApi(params) {
    return $post('News/SearchNewsHomePage_HZ', params)
  },
  // 新闻咨询查询
  SearchZJXTCardTypeApi(params) {
    return $post('UploadZjxtmx/UploadFileFirst', params)
  },

  // 企业文化图片查询
  EnterpriseCultureApi(params) {
    return $post('HomePage/EnterpriseCulture', params)
  },

  // 表单提交
  MessageBoardAddApi(params) {
    return $post('HomePage/MessageBoardAdd', params)
  },


  // 公司简介图片查看
  SearchCompanyProfileFilesApi(params) {
    return $post('CompanyProfile/SearchCompanyProfileFiles', params)
  },
  // 公司简介信息查看
  SearchCompanyDescriptionApi(params) {
    return $post('CompanyProfile/SearchCompanyDescription', params)
  },
  // 新闻动态信息查看
  SearchNews_HZApi(params) {
    return $post('News/SearchNews_HZ', params)
  },
  // 公司风采信息查看
  SearchCompanyStyle_HZApi(params) {
    return $post('CompanyStyle/SearchCompanyStyle_HZ', params)
  },
  // 查询已经上传新闻动态图片
  SearchNews_MXApi(params) {
    return $post('News/SearchNews_MX', params)
  },
  // 查询已经上传公司风采图片
  SearchCompanyStyle_MXApi(params) {
    return $post('CompanyStyle/SearchCompanyStyle_MX', params)
  },
  // 查询已经上传的公司简介图片
  SearchCompanyProfileFilesApi(params) {
    return $post('CompanyProfile/SearchCompanyProfileFiles', params)
  },
  // 查询联系我们页面信息
  SearchContactUsApi(params) {
    return $post('ContactUs/SearchContactUs', params)
  },
  // 查询公司产品页面信息
  SearchCompanyProduct_HZApi(params) {
    return $post('CompanyProduct/SearchCompanyProduct_HZ', params)
  },
  // 查询公司产品所有信息
  SearchCompanyProduct_AllApi(params) {
    return $post('CompanyProduct/SearchCompanyProduct_All', params)
  },



  // 第二版新增开始
  // 关于我们--公司简介文章
  About0urManagementDataSearchApi(params) {
    return $post('EnterpriseQualification/About0urManagementDataSearch', params)
  },
  // 关于我们--公司简介图片
  About0urManagementDataSearchimgApi(params) {
    return $post('EnterpriseQualification/About0urManagementDataSearchimg', params)
  },
  // 新闻中心
  NewsCenterManagementDataSearch_NewsApi(params) {
    return $post('EnterpriseQualification/NewsCenterManagementDataSearch_News', params)
  },
  // 新闻中心--详情
  NewsCenterManagementDataSearch_NewsPicturesApi(params) {
    return $post('EnterpriseQualification/NewsCenterManagementDataSearch_NewsPictures', params)
  },
  // 社会责任
  NewsCenterManagementDataSearch_SocialResponsibilityApi(params) {
    return $post('EnterpriseQualification/NewsCenterManagementDataSearch_SocialResponsibility', params)
  },
  // 企业配置信息查询
  EnterpriseConfigSearchApi(params) {
    return $post('Enterprise/EnterpriseConfigSearch', params)
  },
}
